export const LIBRARY_TABS = {
  ALL: 'all',
  ORIGINAL: 'original',
  VARIANTS: 'variants',
  SELECTED: 'selected',
}

export const LIBRARY_FILTER_PARAMS = {
  SEARCH: 'search',
  TAB: 'tab',
  PAGE: 'page',
  SORT_BY: 'sort_by',
  SORT_ORDER: 'sort_order',
  RATIO: 'ratio',
  IMAGE_TYPE: 'image_type',
}

export const SORT_BY = {
  DATE: 'date',
  NAME: 'image_name',
}

export const SORT_ORDER = {
  DESC: 'desc',
  ASC: 'asc',
}

export const IMAGE_TYPE = {
  ORIGINAL: 'original',
  VARIANT: 'variations',
}

export const LIBRARY_SORT_OPTIONS = ['date_created-desc', 'date_created-asc', 'image_name-asc', 'image_name-desc']

export const buildSortKey = (sortBy, sortOrder) => (
  sortBy && sortOrder ? `${sortBy}-${sortOrder}` : null
)

export const parseSortKey = (sortKey) => {
  const separatorIndex = sortKey.lastIndexOf('-')

  return {
    sortBy: sortKey.slice(0, separatorIndex),
    sortOrder: sortKey.slice(separatorIndex + 1),
  }
}

export const LIBRARY_RATIO_OPTIONS = ['1:1', '9:16', '4:5', '1.91:1']

export const DEFAULT_LIBRARY_FILTERS = {
  search: '',
  sort: null,
  ratios: [],
}